// Sample Pages Carousel
(function() {
  var stage = document.querySelector('.carousel-stage');
  if (!stage) return;

  var slides = stage.querySelectorAll('.sample-slide');
  var dots = document.querySelectorAll('.carousel-dot');
  var idx = 0;
  var total = slides.length;

  function show(i) {
    idx = (i + total) % total;
    slides.forEach(function(s, j) {
      s.classList.toggle('active', j === idx);
      s.setAttribute('aria-hidden', j !== idx);
    });
    dots.forEach(function(d, j) {
      d.classList.toggle('active', j === idx);
    });
  }

  document.querySelector('.carousel-arrow.prev').addEventListener('click', function() { show(idx - 1); });
  document.querySelector('.carousel-arrow.next').addEventListener('click', function() { show(idx + 1); });
  dots.forEach(function(d, i) {
    d.addEventListener('click', function() { show(i); });
  });

  show(0);
})();
